import { Route, Routes, BrowserRouter as Router } from "react-router-dom"
import NotFound from './pages/notfound/index.js';
import Home from './pages/home'
import Reserve from './pages/reserve'
import MyReservations from './pages/my-reservations'
import MapSelect from './pages/map-select'
import VehicleSelect from './pages/vehicle-select'
import TimeSelect from './pages/time-select'
import CarApproval from './pages/car-approval'
import CarReturnApproval from './pages/car-return-approval'
import CarReport from './pages/car-report'
import DelayApproval from './pages/delay-approval'
import Dispatch from './pages/dispatch'
import { UserProvider } from './contexts/UserContext';

function App() {
  return (
  <UserProvider>
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/reserve" element={<Reserve />} />
        <Route path="/my-reservations" element={<MyReservations />} />
        <Route path="/map-select/:locationType" element={<MapSelect />} />
        <Route path="/vehicle-select" element={<VehicleSelect />} />
        <Route path="/time-select" element={<TimeSelect />} />
        <Route path="/car-approval" element={<CarApproval />} />
        <Route path="/car-return-approval" element={<CarReturnApproval />} />
        <Route path="/car-report" element={<CarReport />} />
        <Route path="/delay-approval" element={<DelayApproval />} />
        <Route path="/dispatch" element={<Dispatch />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  </UserProvider>
  );
}

export default App;